"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundTypeEnum = void 0;
var SoundTypeEnum;
(function (SoundTypeEnum) {
    SoundTypeEnum["FileUpload"] = "FileUpload";
    SoundTypeEnum["Elevenlabs"] = "Elevenlabs";
})(SoundTypeEnum = exports.SoundTypeEnum || (exports.SoundTypeEnum = {}));
